import React from 'react';
import PropTypes from 'prop-types';
import IssueCount from "./IssueCount";
import {ShowReportPartial} from "./ShowReportPartial";
import {CONFIG_TYPES} from "../../Configurations/FileTypes";
import {REPORT_TYPES} from "../../Configurations/ReportTypes";
import AlertLink from "./AlertLink";
import {KnownItemPercentage} from "../KnownItemPercentage";

const Feedback = ({row}) => {
    return (<div>
        <IssueCount
            testId={'known-item-issue'}
            issueType={
                (row.original.normalizedRejectCount || row.original.normalizedRejectCount === 0) &&
                <ShowReportPartial path={row.original.archiveLocation}
                                   runId={row.original.normalizationRunId}
                                   rowCount={row.original.normalizedRejectCount}
                                   fileType={Object.values(CONFIG_TYPES).find(config => config.getName() === row.original.fileType)}/>
            }
            original={row.original}
            reportType={REPORT_TYPES.NORMALIZED_FILE}
            fileCount={row.original.normalizedRejectCount}
            retailerId={row.original.retailerId}
        />
        <AlertLink value={row.original.alertIds}/>
        <IssueCount
            testId={'ms-issue'}
            issueType={'MS:'}
            original={row.original}
            reportType={REPORT_TYPES.NORMALIZED_MULTIPLE_SOURCE}
            fileCount={row.original.multiSourceFileCount}
            gcsSuffix={`/${REPORT_TYPES.NORMALIZED_MULTIPLE_SOURCE}`}
            retailerId={row.original.retailerId}
        />
        <KnownItemPercentage original={row.original}/>
    </div>);
};

Feedback.propTypes = {
    row: PropTypes.object
};

export default Feedback;